import { GeoJSON } from 'react-leaflet';

export default function StrataLayer({ geojson, style }) {
  if (!geojson) return null;
  const baseStyle = { color: '#1565c0', weight: 2.5, fillOpacity: 0.07, dashArray: '6 4' };
  return (
    <GeoJSON
      key={JSON.stringify(geojson).slice(0, 80)}
      data={geojson}
      style={style || baseStyle}
      onEachFeature={(feature, layer) => {
        const p = feature.properties || {};
        if (p.name) {
          const ageLine = p.age ? `<br/>גיל: ${p.age}` : '';
          const noteLine = p.note ? `<br/>${p.note}` : '';
          layer.bindPopup(`<strong>${p.name}</strong>${ageLine}${noteLine}`);
        }
      }}
    />
  );
}
